import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getGuestCart, setGuestCart } from "../Cart/cartStorage";
import "./products.css";

function NewProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();

const [limit, setLimit] = useState(5);

// Detect screen size
useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setLimit(5);   // Mobile
    } else {
      setLimit(10);  // PC
    }
  };

  handleResize(); // Run on mount
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const fetchProducts = (newOffset = 0) => {
    setLoading(true);

    axiosInstance
      .get(`/products/?new=true&limit=${limit}&offset=${newOffset}`)
      .then((res) => {
        const newProducts = res.data.results; // ✅ FIXED HERE

        if (!Array.isArray(newProducts)) {
          console.error("API did not return array:", res.data);
          setLoading(false);
          return;
        }

        // If first load → replace
        if (newOffset === 0) {
          setProducts(newProducts);
        } else {
          setProducts((prev) => [...prev, ...newProducts]);
        }

        // Pagination check
        if (newProducts.length < limit) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }

        setOffset(newOffset + limit);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

useEffect(() => {
  fetchProducts(0);
}, [limit]);

  const handleAddToCart = (item, e) => {
    e.stopPropagation();

    const token = localStorage.getItem("access");

    if (token) {
      axiosInstance
        .post("/cart/cart/", { product: item.id, quantity: 1 })
        .then(() => {
          toast.success("Added to cart ❤️");
          window.dispatchEvent(new Event("cartUpdated"));
          navigate("/cart");
        })
        .catch(() => toast.error("Failed ❌"));
    } else {
      const cart = getGuestCart();
      const existing = cart.find((c) => c.product_id === item.id);

      if (existing) {
        existing.quantity += 1;
      } else {
        cart.push({
          product_id: item.id,
          quantity: 1,
          price: item.price,
          title: item.product_title,
          image: item.images?.[0]?.image || "",
        });
      }

      setGuestCart(cart);
      window.dispatchEvent(new Event("cartUpdated"));
      toast.success("Added to cart ❤️");
      navigate("/cart");
    }
  };

  return (
    <div className="product-container">
      <h2 className="product-title">
        <span>NEW ARRIVALS</span>
      </h2>



<div className="card-grid">
  {/* Show Skeletons when loading and no products are visible yet */}
  {loading && products.length === 0 && (
    // Creates an array of length 'limit' to show the right amount of skeletons
    Array.from({ length: limit }).map((_, index) => (
      <div key={index} className="skeleton-card">
        <div className="skeleton skeleton-img"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-btn"></div>
      </div>
    ))
  )}

  {/* Existing Empty State */}
  {!loading && products.length === 0 && (
    <h3>No new products available</h3>
  )}

  {/* Real Products Mapping */}
  {products.map((item) => (
    <div
      key={item.id}
      className="product-card"
      onClick={() => navigate(`/product/${item.id}`)}
    >
      {/* ... rest of your existing product card code ... */}
      {item.total_quantity_sold >= 20 && (
        <div className="trending-badge"><span>🔥</span> Trending</div>
      )}
      
      <img src={item.images?.[0]?.image || ""} className="card-img" alt={item.product_title} />
      <h3 className="card-name">{item.product_title}</h3>
      
<div className="price-section">

{(() => {

  const price = item.sizes && item.sizes.length > 0
    ? Math.min(...item.sizes.map(s => s.price))
    : Number(item.price);

  const discount = 20;
  const originalPrice = Math.round(price * (1 + discount / 100));

  return (
    <>
      <span className="discounted-price">
        ₹{price}
      </span>

      <span className="original-price">
        ₹{originalPrice}
      </span>

      <span className="discount-badge">
        {discount}% OFF
      </span>
    </>
  );

})()}

</div>

      <button className="add-cart-btn" onClick={(e) => handleAddToCart(item, e)}>
        <b>Add to Cart</b>
      </button>
    </div>
  ))}
</div>
      {/* ✅ View More Button on Top */}
      {hasMore && !loading && (
        <div className="load-more-container-top">
          <button
            className="load-more-btn"
            onClick={() => fetchProducts(offset)}
          >
            View More
          </button>
        </div>
      )}
      {/* Bottom Loading */}
{/* Bottom Loading Skeletons */}
{loading && products.length > 0 && (
  <div className="card-grid" style={{ marginTop: '20px' }}>
    {Array.from({ length: limit }).map((_, index) => (
      <div key={index} className="skeleton-card">
        <div className="skeleton skeleton-img"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-btn"></div>
      </div>
    ))}
  </div>
)}

      {!hasMore && products.length > 0 && (
        <div style={{ textAlign: "center", margin: "20px" }}>
          No more products
        </div>
      )}
    </div>
  );
}

export default NewProducts;
